import api from '@app/api'

import type { UserDto } from './dtos'

export const AUTH_URL = {
  user: '/auth/user/'
} as const

export const getUser = async (): Promise<UserDto> => {
  const response = await api.get<UserDto>(AUTH_URL.user)
  return response.data
}
